// src/pages/Auth/AuthLayout.js
// Общий вид страниц входа и регистрации: фон, карточка, поля, кнопка, ошибки, ссылки
import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { isTelegramMiniApp } from '../../utils/platform';
import { CARD_SURFACE_SX, MUTED_TEXT_COLOR, PAGE_BACKGROUND_SX } from '../../styles/tokens';

// Поля — общие с другими формами (подключение сервера)
export { FormField as AuthField, PasswordField } from '../../components/form/FormFields';

const ACCENT = '#ff7043';
const ACCENT_HOVER = '#ff8a65';
const ERROR_COLOR = '#ff6b6b';

export const authLinkSx = {
  color: ACCENT_HOVER,
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
};

export function AuthLayout({ title, onSubmit, children }) {
  const telegram = isTelegramMiniApp();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        // На телефоне — сверху с отступом (без прыжков при открытии клавиатуры), на десктопе — по центру
        alignItems: { xs: 'flex-start', md: 'center' },
        px: 2,
        pt: { xs: 'max(48px, calc(env(safe-area-inset-top, 0px) + 32px))', md: 4 },
        pb: 4,
        boxSizing: 'border-box',
        ...(telegram
          ? { background: 'linear-gradient(180deg, #0d0d0d 0%, #1a1a1a 100%)' }
          : PAGE_BACKGROUND_SX),
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 400 }}>
        <Box sx={{ mb: 3, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '24px', fontWeight: 800, color: '#fff' }}>Pro Resto</Typography>
          <Typography sx={{ mt: 0.5, fontSize: '14px', color: MUTED_TEXT_COLOR }}>
            Аналитика ресторана: выручка, себестоимость и события
          </Typography>
        </Box>

        <Box
          component="form"
          onSubmit={onSubmit}
          sx={{
            ...CARD_SURFACE_SX,
            borderRadius: '16px',
            p: { xs: 3, md: 4 },
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Typography component="h1" sx={{ fontSize: '20px', fontWeight: 700, color: '#fff' }}>
            {title}
          </Typography>
          {children}
        </Box>
      </Box>
    </Box>
  );
}

export function FormError({ children }) {
  if (!children) return null;
  return (
    <Typography role="alert" sx={{ fontSize: '14px', color: ERROR_COLOR }}>
      {children}
    </Typography>
  );
}

export function SubmitButton({ submitting, children }) {
  return (
    <Button
      type="submit"
      fullWidth
      disabled={submitting}
      aria-busy={submitting}
      sx={{
        height: 48,
        p: 0,
        borderRadius: '10px',
        backgroundColor: ACCENT,
        color: '#1a0f0a',
        fontSize: '16px',
        fontWeight: 700,
        textTransform: 'none',
        boxShadow: 'none',
        '&:hover': { backgroundColor: ACCENT_HOVER, boxShadow: 'none' },
        '&.Mui-disabled': { backgroundColor: ACCENT, color: '#1a0f0a', opacity: 0.7 },
        '&.Mui-focusVisible': { outline: '2px solid #fff', outlineOffset: '2px' },
      }}
    >
      {submitting ? <CircularProgress size={22} sx={{ color: '#1a0f0a' }} /> : children}
    </Button>
  );
}
